export default [
    {
        value: 'print_online',
        label: 'Print & Online'
    },
    {
        value: 'online_only',
        label: 'Online Only'
    }
]
